module.exports = __webpack_public_path__ + "static/media/backWave1.0fd8d166.svg";